// What GET /admin/users/{id}/referral-source means, as one display state.
//
// The endpoint answers with three fields because that is the shape of the stored
// data; the dialog needs one state to switch on. Mapping happens here, in a module
// with no React in it, because Jest in this project cannot import any component
// (CRA's resolver does not understand Radix's `exports` subpath maps). This is the
// only part of the feature that gets real test coverage.
//
// The state is named `counted`, NOT `credited` or `rewarded`. The backend flag
// means the referral went onto the referrer's tally; whether a gift was actually
// granted is gated separately by referral_reward_threshold, so with a threshold
// above 1 most counted referrals produce nothing. Naming the state after the
// payout would make the dialog lie.
//
// Returns state, not copy: translation stays in the component, so this stays
// testable without asserting Romanian strings.
export function referralSummary(source) {
  const { used_code: usedCode, referrer_name: referrerName, credited } = source || {};

  if (!usedCode) {
    // `used_code` is the gate. A credited flag without a referrer is corrupt data,
    // and honouring it would invent a referral that never happened.
    return { state: 'none', referrerName: null };
  }

  const name = typeof referrerName === 'string' ? referrerName.trim() : '';
  if (!name) {
    // The code was used, but the referrer's account is gone. That outranks the
    // counted/pending distinction: a tally state beside a missing name explains
    // nothing to whoever opened this dialog.
    return { state: 'referrer_missing', referrerName: null };
  }

  return { state: credited ? 'counted' : 'pending', referrerName: name };
}
